import * as yup from 'yup';

const rangeSchema = yup
  .number()
  .transform((v) => {
    return isNaN(v) ? undefined : v;
  })
  .notRequired()
  .typeError('Range must be a number')
  .min(1, 'Minimum range is 1')
  .max(12, 'Maximum range must not exceed 12');

export const schema = yup.object().shape({
  ranges: yup.array(yup.array(rangeSchema)).notRequired().nullable(),
});
